export default "__VITE_ASSET__BpNRjK0W__"